<template>


    <section> 
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/springer.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  

                        <h1>
                            Lets talk about timelines. 
                        </h1>

                        <p>It can take up to six months to create your book from start to finish.
When are you ready to start if we accept your application for book
publication?</p>


<b-form-radio-group v-model="date_selection" @change="date_selection_change()">
                        <div>
                            <b-form-radio value="4" class="mb-3">
                                ⁠I can start within next four weeks
                            </b-form-radio>
                        </div>
                        <div>
                            <b-form-radio value="custom" class="mb-3">
                                ⁠⁠My start date is
                            </b-form-radio>
                        </div>
                    </b-form-radio-group>
     
                        <div class="col-xl-12" v-if="(date_selection == 'custom')">
                            <base-input prepend-icon="fas fa-calendar" placeholder="Your start date" v-model="custom_date" name="Start date" @keyup="date_selection_change()" rules="required|min:6"></base-input>
                        </div>



                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
    
    
    
    
    
    </template>
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'
import { Select, Option } from 'element-ui'

export default {
    name: 'snap08',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            date_selection: '',
            custom_date: '',
            loading: false,
        }
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
             //   console.log(this.currentSnapWizard.project_start_date);
            if (
                this.date_selection == "4" || this.date_selection == "custom"
            ) {

                if (this.date_selection == "4"){
                    this.currentSnapWizard.project_start_date = "in 4 weeks";
                }

                if (this.date_selection == "custom"){
                    this.currentSnapWizard.project_start_date = this.custom_date;
                }

                if(this.currentSnapWizard.project_start_date != ''){
                    console.log("VALID ENABLING NEXT");
                    this.$emit('allowProceed');
                    this.$emit('showFooterNav');
                    return true;
                }
                else{
                    this.$emit('denyProceed');
                    this.$emit('hideFooterNav');
                    return false;
                }


            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
        date_selected() {
            if(this.date_selection == "select_date"){
                return true;
            }
            return false;
        },
        date_selection_change() {
            console.log(this.custom_date);
            this.allDataValidated();
            /*
            if(this.currentSnapWizard.date_selected == "in the next 4 weeks" && this.currentSnapWizard.project_start_date != "in the next 4 weeks"){
                this.currentSnapWizard.project_start_date = "in the next 4 weeks";
                return true;
            }
            if(this.currentSnapWizard.date_selected == "custom"){
                this.currentSnapWizard.project_start_date = "";
                return true;
            }
            */
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                this.allDataValidated();
            },
            deep: true
        },

    },
    mounted() {
        this.$emit('denyProceed');
        this.$emit('hideFooterNav');
        this.allDataValidated();
       // this.currentSnapWizard.project_start_date = "";
    }
};
</script>